'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var useMap = require('./useMap.js');
var composePosition = require('./utils/composePosition.js');
var attachEventListeners = require('./utils/attachEventListeners.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _excluded = ["position", "icon", "label", "title", "draggable"];
var VALID_MARKER_EVENTS = new Set(['onClick', 'onDoubleClick', 'onDragEnd', 'onMouseDown', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onRecenter']);
var markerListenerProps = [...VALID_MARKER_EVENTS].reduce((result, handle) => {
  result[handle] = index.func;
  return result;
}, {});
var Marker = _ref => {
  var {
    position,
    icon,
    label,
    title,
    draggable
  } = _ref,
      listeners = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var {
    map,
    google
  } = useMap.useMap();
  var [marker, setMarker] = React__namespace.useState(null);
  React__namespace.useEffect(() => {
    if (map && google && !marker) {
      var composedPosition = composePosition.composePosition({
        position,
        google
      });
      var newMarker = new google.maps.Marker({
        position: composedPosition,
        map,
        icon,
        label,
        title,
        draggable
      });
      attachEventListeners.attachEventListeners(_rollupPluginBabelHelpers.objectSpread2({
        target: newMarker
      }, listeners));
      setMarker(newMarker);
    }
  }, [map, google, marker]); // Update the marker's position when `position` prop changes.

  React__namespace.useEffect(() => {
    if (marker) {
      var newPosition = composePosition.composePosition({
        position,
        google
      });
      marker.setPosition(newPosition);
    }
  }, [marker, position]);
  return null;
};
Marker.propTypes = _rollupPluginBabelHelpers.objectSpread2({
  position: index.object,
  icon: index.node,
  label: index.string,
  title: index.string,
  draggable: index.bool
}, markerListenerProps);

exports.Marker = Marker;
